import { UsePlanCostSummaryResponse } from '../../../hooks/usePlanCostSummarySWR'
import { useEffect, useState } from 'react'

/**
 * Handle the scenerio of a user who is on an Org plan (Pro+ or Pro Flex)
 * and attempt to downgrade to Pro or lower (usually thru /pricing)
 *
 * For more {@see https://app.shortcut.com/flowcode/story/66961}
 */
export const useHasPlanDowngradeError = ({
  error
}: {
  error: UsePlanCostSummaryResponse['error']
}): { hasDowngradeError: boolean } => {
  const [hasDowngradeError, setHasDowngradeError] = useState(false)

  useEffect(() => {
    if (error?.message === 'Downgrade not supported') {
      setHasDowngradeError(true)
    }
  }, [error])

  return { hasDowngradeError }
}
